import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(timezone);

export const convertTimestampToDay = (timestamp, userTimezone) => {
  const tz = userTimezone || dayjs.tz.guess()
  if (!timestamp || isNaN(Number(timestamp))) {
    return 'Loading'
  }
  const date = dayjs.tz(Number(timestamp), tz)
  if (!date.isValid()) {
    return 'Loading'
  }
  return date.format('dddd').toLowerCase();
};
